import { GenericObject } from "./common.types";
import { SIGNUP_TYPE } from "./enums/signup";

export const SIGNUP_FORM_FIELDS = {
  EMAIL: "email",
  SCHOOL_NAME: "schoolName",
  CREATOR_TYPE: "creatorType",
  PHONE: "phone",
  COURSE_CATEGORY: "courseCategory",
  ORG_IMG: "orgImg",
  ORG_NAME: "orgName",
  ORG_DESCRIPTION: "orgDescription",
  ALREADY_TEACHING: "alreadyTeaching",
  AUDIENCE_SIZE: "audienceSize",
  PROFESSION: "profession",
  OTHER_COURSE_CATEGORY: "otherCourseCategory",
  OTHER_PROFESSION: "otherProfession",
};

export type CreatorSignupType = {
  signupType: SIGNUP_TYPE;
  email?: string;
  password?: string;
  countryCode?: string; // This is phoneCode: '91', etc.
  phone?: string;
  name?: string;
  recaptchaToken?: string;
  utmFields?: GenericObject;
  gref?: string;
  skipOnboarding?: string | boolean;
  destination?: string;
  _fprom_code?: string;
  _fprom_track?: string;
  gclid?: string;
  orgCountryCode?: string; // 'kr'
  appsumoCode?: string;
};

export type SignUpOTPType = {
  email: string;
  phone: string;
  type: string;
  token: string;
  name: string;
  source?: string;
};

export type OTPVerificationResponse = {
  response: boolean;
  message?: string;
};

export type SignUpDataType = {
  email?: string;
  schoolName?: string;
};
